<template>
  <div>
    <p
      class="has-text-centered gant-text is-bold is-size-4-desktop is-size-6-mobile mb-5"
      style="position:relative; z-index: 9;"
    >
      {{ bookingMessage.message }}
    </p>

    <div class="columns mt-3" style="position:relative; z-index: 8;">
      <div class="column">
        <div v-if="orderedSegments['flight']">
          <ItineraryFlight
            :segments="orderedSegments['flight']"
            :traveler="$store.state.travellersAndTrips.currentTravellerProfile"
            :guests="$store.state.bookTravel.guests"
            :multiLegs="multiLegs"
            @add="$nav.pushRouteTo({ name: 'BookingFlights'})"
            class="mt-2 itinerary-flight-large"
          />
        </div>
        <div v-else class="ml-5 mr-5" v-animate-css="'fadeIn'">
          <SVGPlaneClouds />
          <div>
            <b-button
              size="is-medium"
              @click="$nav.pushRouteTo({ name: 'BookingFlights'})"
              expanded
              v-html="addText('flight')"
              :disabled="modifyingTrip"
            >
            </b-button>
          </div>
        </div>
      </div>

      <div class="column">
        <div v-if="orderedSegments['hotel']">
          <ItineraryHotel
            :sol="orderedSegments['hotel']"
            :key="sol.hotel.key"
            @add="$nav.pushRouteTo({ name: 'BookingHotels'})"
          />
        </div>
        <div v-else class="ml-5 mr-5" v-animate-css="'fadeIn'">
          <SVGHotelBuilding />
          <div class="">
            <b-button
              size="is-medium"
              @click="$nav.pushRouteTo({ name: 'BookingHotels'})"
              expanded
              v-html="addText('hotel')"
            >
            </b-button>
          </div>
        </div>
      </div>

      <div class="column">
        <div v-if="orderedSegments['car']">
          <ItineraryCar
            :sol="orderedSegments['car']"
            :key="sol.car.id"
            @add="$nav.pushRouteTo({ name: 'BookingCars'})"
          />
        </div>
        <div v-else class="ml-5 mr-5" v-animate-css="'fadeIn'">
          <SVGCarLady />
          <div class="">
            <b-button
              size="is-medium"
              @click="$nav.pushRouteTo({ name: 'BookingCars'})"
              expanded
              v-html="addText('car')"
            >
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="bookingMessage.isBooking"
      class="is-flex is-justify-content-center is-align-content-center mt-5"
    >
      <b-button
        label="Proceed to Checkout"
        @click="$nav.pushRouteTo({ name: 'BookingCheckout' })"
        type="is-primary"
        class="is-center pl-6 pr-6"
      />
    </div>
  </div>
</template>

<script>
import ItineraryFlight from "./ItineraryFlight.vue";
import ItineraryCar from "./ItineraryCar.vue";
import ItineraryHotel from "./ItineraryHotel.vue";
import SVGHotelBuilding from "../SVGs/SVG-HotelBuilding";
import SVGCarLady from "../SVGs/SVG-CarLady";
import SVGPlaneClouds from "../SVGs/SVG-PlaneClouds";
import bookingMixin from "../../mixins/bookingMixin";

export default {
  name: "ItineraryPieceBooking",
  mixins: [bookingMixin],
  components: {
    ItineraryFlight,
    ItineraryCar,
    ItineraryHotel,
    SVGHotelBuilding,
    SVGCarLady,
    SVGPlaneClouds,
  },
  props: {
    sol: Object,
  },
  computed: {


  },
  methods: {

    addText(type) {
      let text = `Add a ${type}`;
      if (this.bookingLocation) {
        let lowerCase = this.bookingLocation.city.toLowerCase();
        text = `Add a ${type} near&nbsp;<span class="gant-text">${lowerCase
          .charAt(0)
          .toUpperCase() + lowerCase.slice(1)}</span>`;
      }
      return text;
    },

  },
  mounted() {},
};
</script>

<style scoped>
.itinerary-flight-large{
max-height: 500px;
overflow-y: auto;
}
</style>
